
import React from "react";
import { NavLink } from "react-router-dom";

function Navbar() {

    return (
        <nav>
        <NavLink to="/">Home</NavLink>
        <NavLink to="/Blues">Blues</NavLink>
        <NavLink to="/About">About me</NavLink>
        <NavLink to="/Contact">Contact Me</NavLink>
        {/* <a href="https://lightningdesignsystem.com/utilities/text/">styling</a> */}
    </nav>
    )
  }

  export default Navbar;